import { render } from "./ViewerBlock.vue?vue&type=template&id=8b51db6c&scoped=true&ts=true"
import script from "./ViewerBlock.vue?vue&type=script&lang=ts"
export * from "./ViewerBlock.vue?vue&type=script&lang=ts"

import "./ViewerBlock.vue?vue&type=style&index=0&id=8b51db6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b51db6c"]])

export default __exports__